import { render, staticRenderFns } from "./breadcrumbNav.vue?vue&type=template&id=656a0ca9&"
import script from "./breadcrumbNav.vue?vue&type=script&lang=js&"
export * from "./breadcrumbNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports